import {
  defaultFont,
  primaryBoxShadow,
  infoBoxShadow,
  successBoxShadow,
  warningBoxShadow,
  dangerBoxShadow,
  roseBoxShadow,
  whiteColor,
  blackColor,
  grayColor,
  infoColor,
  successColor,
  dangerColor,
  roseColor,
  primaryColor,
  warningColor,
  hexToRgb
} from "../../material-dashboard-react";

const snackbarContentStyle = {
  root: {
    ...defaultFont,
    flexWrap: "unset",
    position: "relative",
    padding: "16px 20px",
    lineHeight: "20px",
    marginBottom: "20px",
    fontSize: "14px",
    backgroundColor: whiteColor,
    color: grayColor[7],
    borderRadius: "12px",
    minWidth: "300px",
    maxWidth: "450px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backdropFilter: "blur(10px)",
  },
  messageContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  top20: {
    top: "20px"
  },
  top40: {
    top: "40px"
  },
  info: {
    backgroundColor: "#e3f2fd",
    color: "#1565c0",
    borderLeft: "4px solid #1976d2",
    "& $icon": {
      color: "#1976d2",
    }
  },
  success: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    borderLeft: "4px solid #4caf50",
    "& $icon": {
      color: "#4caf50",
    }
  },
  warning: {
    backgroundColor: "#fff3e0",
    color: "#e65100",
    borderLeft: "4px solid #ff9800",
    "& $icon": {
      color: "#ff9800",
    }
  },
  danger: {
    backgroundColor: "#ffebee",
    color: "#c62828",
    borderLeft: "4px solid #f44336",
    "& $icon": {
      color: "#f44336",
    }
  },
  primary: {
    backgroundColor: "#f3e5f5",
    color: "#6a1b9a",
    borderLeft: "4px solid #9c27b0",
    "& $icon": {
      color: "#9c27b0",
    }
  },
  rose: {
    backgroundColor: roseColor[0],
    color: whiteColor,
    borderLeft: "4px solid " + roseColor[3],
    ...roseBoxShadow
  },
  message: {
    padding: "0",
    display: "block",
    maxWidth: "89%",
    fontWeight: 500,
  },
  close: {
    width: "18px",
    height: "18px",
    opacity: 0.7,
    transition: "opacity 0.2s ease",
    "&:hover": {
      opacity: 1,
    }
  },
  iconButton: {
    width: "32px",
    height: "32px",
    padding: "4px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
      transform: "scale(1.1)",
    }
  },
  icon: {
    display: "block",
    width: "24px",
    height: "24px",
    flexShrink: 0,
  },
  infoIcon: {
    color: infoColor[3]
  },
  successIcon: {
    color: successColor[3]
  },
  warningIcon: {
    color: warningColor[3]
  },
  dangerIcon: {
    color: dangerColor[3]
  },
  primaryIcon: {
    color: primaryColor[3]
  },
  roseIcon: {
    color: roseColor[3]
  },
  iconMessage: {
    display: "block",
    flex: 1,
  },
  actionRTL: {
    marginLeft: "-8px",
    marginRight: "auto"
  }
};

export default snackbarContentStyle;
